import { useEffect, useRef } from 'react';
import { useMondayContext } from '@/context/MondayContextProvider';
import { trackPublicView } from '@/services/public-view-event';

const CONTEXT_FALLBACK_MS = 1500;

export function PublicViewTracker() {
  const { context } = useMondayContext();
  const firedRef = useRef(false);

  useEffect(() => {
    if (firedRef.current) return undefined;

    if (context) {
      firedRef.current = true;
      trackPublicView(context);
      return undefined;
    }

    const timer = setTimeout(() => {
      if (firedRef.current) return;
      firedRef.current = true;
      trackPublicView(undefined);
    }, CONTEXT_FALLBACK_MS);
    return () => clearTimeout(timer);
  }, [context]);

  return null;
}
